export default __webpack_public_path__ + "static/media/alexandra.177932cb.jpg";